import React from 'react';

interface CTAButtonProps {
  children: React.ReactNode;
  href: string;
  variant?: 'primary' | 'secondary' | 'white';
  className?: string;
}

export const CTAButton: React.FC<CTAButtonProps> = ({
  children,
  href,
  variant = 'primary',
  className = '',
}) => {
  const getButtonStyles = () => {
    switch (variant) {
      case 'primary':
        return 'bg-blue-700 text-white hover:bg-blue-800';
      case 'secondary':
        return 'bg-transparent border border-white text-white hover:bg-blue-600';
      case 'white':
        return 'bg-white text-blue-700 hover:bg-blue-50';
      default:
        return 'bg-blue-700 text-white hover:bg-blue-800';
    }
  };

  return (
    <a 
      href={href}
      className={`inline-block px-6 py-3 rounded-lg font-medium transition-all duration-300 text-center ${getButtonStyles()} ${className}`}
    >
      {children}
    </a>
  );
};
